<div (appHovered)="isCardHovered = $event" [ngStyle]="backgroundStyle" class="project-card">
  <!-- a tag for SEO purpose -->
  <a [attr.href]="projectUrl" style="display: none;"></a>
  <div class="tip-pin-share-block d-sm-flex">
    <div class="tip" >{{"PREFERENCES_POPUP_1." + northStar + "_preferencespopup1" | translate | capitalize}}</div>
    <div class="tip" *ngIf="northStar2">{{"PREFERENCES_POPUP_1." + northStar2 + "_preferencespopup1" | translate | capitalize}}</div>
    <div class="tip" *ngIf="northStar3">{{"PREFERENCES_POPUP_1." + northStar3 + "_preferencespopup1" | translate | capitalize}}</div>
  </div>
  <div class="info">
    <div *ngIf="continent === 'Worldwide'; else noworldwideproject" class="location">
      {{continent}}
    </div>
    <ng-template #noworldwideproject>
      <div class="location">
        {{continent}} - {{country}}
      </div>
    </ng-template>
    <div class="name">{{name}}</div>
    <div class="organization">{{ 'PROJECT_CARD.by_projectcard' | translate }} {{ organization }}</div>
    <div *ngIf="vettedBy !== ProjectsConstants.VETTED_BY_NOOS" class="proposed-by">{{ 'PROJECT_CARD.proposed_by' |
      translate }}{{ vettedBy }}
    </div>
    <span *ngIf="isLogged" class="supported-logos">
      <span *ngIf="isSupported" class="icon supported"></span>
      <span *ngIf="isOwnMoney(id)" class="icon supported own-money"></span>
    </span>
  </div>
</div>
